import apiClient from "./apiClient";

/**
 * 💡 SHIM: clientsApi.js
 * 
 * Este archivo actúa como puente para que todos los servicios API existentes 
 * (que usan Fetch-like request) utilicen el nuevo apiClient de Axios.
 * 
 * Esto asegura que TODAS las peticiones hereden:
 * 1. Interceptores de Auth / Refresh Token.
 * 2. Inyección automática de X-Sede-ID y X-Empresa-ID.
 */
export default async function request(endpoint, options = {}) {
  // Convertir opciones de Fetch a Axios
  const config = {
    url: endpoint,
    method: options.method || "GET",
    data: (options.body instanceof FormData) ? options.body : (options.body ? JSON.parse(options.body) : undefined),
    headers: options.headers || {},
    responseType: options.responseType || "json",
  };

  try {
    const response = await apiClient(config);

    // Mimetizar el objeto Response de Fetch para compatibilidad (.json() y .blob())
    return {
      status: response.status,
      ok: true,
      json: async () => response.data,
      text: async () => JSON.stringify(response.data),
      blob: async () => response.data,
    };
  } catch (error) {
    if (error.response) {
      // Si hay respuesta del servidor pero con error (ej. 403)
      return {
        status: error.response.status,
        ok: false,
        json: async () => error.response.data,
      };
    }
    // Si es un error de red o similar
    throw error;
  }
}
